import ConcurrentQueue from '@/utils/ConcurrentQueue'

const MAX_CONCURRENT_IMAGES = 5
const MAX_CONCURRENT_PDFS = 5

/**
 * Store for different concurrent requests that can be used for multiple components
 */
export default {
  namespaced: true,
  state: () => ({
    concurrentImageRequests: new ConcurrentQueue(MAX_CONCURRENT_IMAGES),
    concurrentPDFRequests: new ConcurrentQueue(MAX_CONCURRENT_PDFS)
  }),
  mutations: {
    addImageRequest (state: any, request: () => Promise<any>) {
      state.concurrentImageRequests.enqueue(request)
    },
    addPDFrequest (state: any, request: () => Promise<any>) {
      state.concurrentPDFRequests.enqueue(request)
    }
  }
}
